<template>
  <span style="vertical-align: inherit; display: inline-block;">
    <a-tooltip placement="top">
      <template #title>
        <span class="m-0">{{ user.fullname }}</span>
      </template>
      <span class="user-badge flex-row gap-xxs align-items-center">
        <a-avatar icon="user" v-bind:size="size" :src="avatarUri" v-bind:class="{ 'white-border': border }">
        </a-avatar>
        <span style="vertical-align: middle;" v-if="displayName">{{ user.first_name }}</span>
      </span>
    </a-tooltip>
  </span>
</template>

<script>
export default {
  name: 'UserBadgeComponent',
  props: {
    user: {
      type: Object,
      required: true
    },
    displayName: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    avatarUri () {
      return '/user/' + this.user.id + '/avatar'
    },
  }
}
</script>
<style>
.user-badge {
  vertical-align: inherit;
  display: inline-block;
  padding: 0.5rem;
  margin: -.5rem 0;
  border-radius: .2rem;
  transition: background-color .5s;
}

.user-badge:hover {
  background-color: #0000000a;
}

.user-badge .white-border {
  border-radius: 100%;
  border: solid white 2px;
}
</style>
